<template>
<div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Órdenes</span>
    <div class="filter-colum-sections">
      <v-text-field
        style="width: 320px;"
        type="text"
        placeholder="Buscar"
        v-model="currentSearch"
        color="#222222"
        variant="underlined">
        <template v-slot:append-inner>
          <v-icon color="#222222" icon="mdi-magnify" size="small"/>
        </template>
      </v-text-field>
    </div>
  </div>

  <div class="select-filter-container">
    <div>
      <span class="title-filter">De </span>
      <!--Aqui quiero poner el date picker-->
      <v-dialog v-model="showPS" max-width="330">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props"
          color="#FF5700"
          variant="text">
            {{dateStartFormatted}}
          </v-btn>
        </template>
        <v-card>
          <v-date-picker
            v-model="dateStart"
            type="date"
            :allowed-dates="allowedPastDates"
            hide-header
            hide-actions
            locale="es"
            @update:model-value="onDateStartSelected"/>
        </v-card>
      </v-dialog>
      <!--End Date-->
      <span class="title-filter">a </span>
      <!--Aqui quiero poner el date picker-->
      <v-dialog v-model="showPE" max-width="330">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props"
          color="#FF5700"
          variant="text">
            {{dateEndFormatted}}
          </v-btn>
        </template>
        <v-card>
          <v-date-picker
            v-model="dateEnd"
            type="date"
            :allowed-dates="allowedPastDates"
            hide-header
            hide-actions
            locale="es"
            @update:model-value="onDateEndSelected"/>
        </v-card>
      </v-dialog>
      <!--End Date-->
    </div>
    <div class="select-filter-container-right">
       <v-btn
          append-icon="mdi-download"
          variant="text"
          style=" margin-right: 20px;"
          color="#FF5700"
          @click="exportExcel">
            Descargar Registros
        </v-btn>
      <div class="autocomplete-container">
        <span class="title-filter">POS:</span>
        <v-select
            v-model="filterSelected"
            :items="filterData"
            item-title="label"
            item-value="value"
            density="compact"
            hide-details="auto"
            variant="solo"
            class="no-bg"/>
      </div>
    </div>
  </div>

  <orders-table :orders="orders" @refreshList="getList"/>

  <div v-if="totalPages > page"
    class="container-btn-more">
    <button class="btn-text" @click="moreData">
      + Mostrar más
    </button>
  </div>

  <new-order ref="addModal" @refreshList="getList"/>

</div>
</template>
<script>
import terminalsApi from '@/api/terminalsApi'
import NewOrder from '@/components/forms/NewOrder.vue'
import dateTransform from '@/utils/dateTransform'
import OrdersTable from '../tables/OrdersTable.vue'
import ordersApi from '@/api/ordersApi'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  name: 'CommerciaVueOrders',
  components: {
    OrdersTable,
    NewOrder
  },
  data () {
    return {
      dateStart: new Date(),
      showPS: false,
      dateEnd: new Date(),
      showPE: false,

      business: this.$store.getters.business,
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: [{ value: 'Todos', label: 'Todos' }],

      orders: [],
      page: 1,
      totalPages: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    dateStartFormatted () {
      return dateTransform.formatInput(this.dateStart)
    },
    dateEndFormatted () {
      return dateTransform.formatInput(this.dateEnd)
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance') {
      this.$router.push({ name: 'dashboard' })
    }
    this.page = 1
    this.getPos()
    this.getList()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateStart (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateEnd (newVal, oldVal) {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    moreData () {
      this.page += 1
      this.getList()
    },
    dateSelected (date) {
      console.log(this.date)
    },
    addModal () {
      this.$refs.addModal.open()
    },
    clearSearch () {
      this.currentSearch = ''
      this.page = 1
      this.getList()
    },
    getStatus (status) {
      switch (status) {
        case 'new':
          return 'Nueva'
        case 'preparing':
          return 'Preparando'
        case 'ready':
          return 'Lista para entrega'
        case 'delivered':
          return 'Entregada'
        case 'canceled':
          return 'Cancelada'
      }
    },
    getMethod (method) {
      switch (method) {
        case 'cash':
          return 'Efectivo'
        case 'credit':
          return 'Credito'
        case 'debit':
          return 'Debito'
        case 'combined':
          return 'Combinado'
        case 'transfer':
          return 'Transferencia'
        case 'deposit':
          return 'Deposito'
        default: return method
      }
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    },
    async getList () {
      console.log('Getting list')
      if (this.filterSelected === 'Todos') {
        const dataResponse = await ordersApi.listByBussines(
          this.business._id,
          this.currentSearch,
          this.page,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          'all', 20)
        this.orders = this.page === 1
          ? (dataResponse.data || [])
          : [...this.orders, ...(dataResponse.data || [])]
        this.totalPages = dataResponse.totalPages || 0
      } else {
        const dataResponse = await ordersApi.listByPos(
          this.filterSelected,
          this.currentSearch,
          this.page,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          'all', 20)
        this.orders = this.page === 1
          ? (dataResponse.data || [])
          : [...this.orders, ...(dataResponse.data || [])]
        this.totalPages = dataResponse.totalPages || 0
      }
    },
    onDateStartSelected (newDate) {
      this.dateStart = newDate
      this.showPS = false
    },
    onDateEndSelected (newDate) {
      this.dateEnd = newDate
      this.showPE = false
    },
    allowedPastDates (date) {
      const today = new Date()
      return date <= today
    },
    getProducts (products) {
      return products.reduce((total, product) => total + (product.quantity || 0), 0)
    },

    async exportExcel () {
      let dataResponse = null
      if (this.filterSelected === 'Todos') {
        dataResponse = await ordersApi.listByBussines(
          this.business._id,
          this.currentSearch,
          1,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          'all',
          10000)
      } else {
        dataResponse = await ordersApi.listByPos(
          this.filterSelected,
          this.currentSearch,
          1,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          'all',
          10000)
      }

      const arrayOrders = []
      arrayOrders.push([
        'CREADO', 'ORDEN', 'PUNTO DE VENTA',
        'PRODUCTOS VENDIDOS', 'DESCUENTO (%)', 'TOTAL ($)', 'STATUS',
        'METODO DE PAGO',
        'EFECTIVO', 'DEBITO', 'CREDITO', 'TRANSFERENCIA', 'DEPOSITO',
        'CREADO POR'])

      const arrayProducts = []
      arrayProducts.push(['ORDEN', 'CODIGO', 'PRODUCTO',
        'CANTIDAD', 'PRECIO UNITARIO', 'TOTAL ($)'])

      const arrayProductsList = []
      arrayProductsList.push(['CODIGO', 'PRODUCTO', 'CANTIDAD', 'PRECIO UNITARIO', 'TOTAL ($)'])

      const totals = [0, 0, 0, 0, 0, 0]
      const arrayTotals = []

      const groupedProducts = {}

      for (const item of dataResponse.data) {
        const fecha = new Date(item.created)
        const opcion = { day: '2-digit', month: 'short', year: 'numeric' }
        const dateFormated = new Intl.DateTimeFormat('es-ES', opcion).format(fecha)

        totals[0] += item.payments[0].cash
        totals[1] += item.payments[0].debit
        totals[2] += item.payments[0].credit
        totals[3] += item.payments[0].transfer
        totals[4] += item.payments[0].deposit

        arrayOrders.push([
          dateFormated,
          item.folio,
          item.terminal.name,
          this.getProducts(item.products),
          item.discount,
          item.amount - (item.amount * (item.discount / 100)),
          this.getStatus(item.status),
          this.getMethod(item.method),
          item.payments[0].cash,
          item.payments[0].debit,
          item.payments[0].credit,
          item.payments[0].transfer,
          item.payments[0].deposit,
          item.createdBy.name
        ])

        for (const product of item.products) {
          arrayProducts.push([
            item.folio,
            product.sku,
            product.name,
            product.quantity,
            product.price,
            product.quantity * product.price
          ])

          // Agrupar por _id en groupedProducts
          if (!groupedProducts[product._id]) {
            groupedProducts[product._id] = {
              sku: product.sku,
              name: product.name,
              quantity: 0,
              price: product.price,
              total: 0
            }
          }

          groupedProducts[product._id].quantity += product.quantity
          groupedProducts[product._id].total += product.quantity * product.price
        }
      }

      // Convertir objeto agrupado a arrayProductsList
      for (const key in groupedProducts) {
        const prod = groupedProducts[key]
        arrayProductsList.push([
          prod.sku,
          prod.name,
          prod.quantity,
          prod.price,
          prod.total
        ])
      }

      const workbook = XLSX.utils.book_new()
      const name = dateTransform.formatInput(this.dateStart) +
      ' al ' +
      dateTransform.formatInput(this.dateEnd)

      const dataOrders = XLSX.utils.aoa_to_sheet(arrayOrders)
      const boockOrders = 'Ordenes'
      XLSX.utils.book_append_sheet(workbook, dataOrders, boockOrders)
      const dataProducts = XLSX.utils.aoa_to_sheet(arrayProducts)
      const boockProducts = 'Productos por orden'
      XLSX.utils.book_append_sheet(workbook, dataProducts, boockProducts)

      const dataConglomerado = XLSX.utils.aoa_to_sheet(arrayProductsList)
      const boockConglomerado = 'Concentrado de productos'
      XLSX.utils.book_append_sheet(workbook, dataConglomerado, boockConglomerado)

      arrayTotals.push(['Efectivo', totals[0]])
      arrayTotals.push(['Debito', totals[1]])
      arrayTotals.push(['Credito', totals[2]])
      arrayTotals.push(['Transferencia', totals[3]])
      arrayTotals.push(['Deposito', totals[4]])
      arrayTotals.push(['Total', totals[0] + totals[1] + totals[2] + totals[3] + totals[4]])

      const dataTotal = XLSX.utils.aoa_to_sheet(arrayTotals)
      const boocktotal = 'Totales'
      XLSX.utils.book_append_sheet(workbook, dataTotal, boocktotal)

      XLSX.writeFile(workbook, `Ordenes ${name}.xlsx`)
    }

  }
}
</script>

<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
</style>
